import inject from 'seacreature/lib/inject'

inject('pod', () => {
  inject('404', () => {
    return <div>404 - Not Found</div>
  })
})
